module.exports = "/call-frontend/img/bg_welcome_light.eb9da307.png";